var render, staticRenderFns
import script from "./Button.vue?vue&type=script&lang=tsx&"
export * from "./Button.vue?vue&type=script&lang=tsx&"
import style0 from "./Button.vue?vue&type=style&index=0&id=0cdf81da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports